import makeStyles from '@material-ui/core/styles/makeStyles'

const useStyles = makeStyles(() => ({
    shippingInfoText: {
        padding: '0 5px',
        margin: '24px 0 0 0',
        maxWidth: 450,
        ['@media (min-width: 600px)']: {
            maxWidth: 500,
        },
    },
}))

const ShippingInfoText = () => {
    const classes = useStyles()

    return (
        <div className={classes.shippingInfoText}>
            <p>
                Build a personalized gift card with a photo. Printed and shipped
                same-day for orders placed <strong>by 4pm ET (Mon-Fri)</strong>.
            </p>
            <p>
                Images subject to review in accordance with our image
                guidelines. <strong>For use in US only.</strong>
            </p>
            <p>
                If purchased today the card will expire on Thu Aug 21 2031.
                However, the <strong>funds do not expire.</strong>
            </p>
        </div>
    )
}

export default ShippingInfoText
